export default "__VITE_ASSET__ccc421f6__"